
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import cookies from 'js-cookie'
import classes from './Subscribe.module.css'
import img_logo from '../Assets/high_logo.png'
import { base_url } from '../Services/api';
import Cookies from "js-cookie";


const Otp = ({ serviceName }) => {
    const ani = cookies.get('number')

    const [input1, setInput1] = useState('');
    const [input2, setInput2] = useState('');
    const [input3, setInput3] = useState('');
    const [input4, setInput4] = useState('');
    const [loading, setLoading] = useState(false);
      const [tVal,setTVal] = useState(null)
          const [show,setShow] = useState(false);
      
    
    const urlParams = new URLSearchParams(window.location.search);
    const otpId = urlParams.get('id');

    const navigate = useNavigate()
    const [time, setTime] = useState(60);
    const pack = Cookies.get('pack');
    const extId = Cookies.get('extId')


     const getScript = async () => {
  if (window.__dcbScriptLoaded) return;

  // claim the lock immediately, before the async call starts —
  // otherwise a second fast invocation can slip through before
  // the first one ever sets the flag
  window.__dcbScriptLoaded = true;

  setLoading(true);

  try {

    const getScript = await axios.post(`${base_url}/api/v1/evina/script`, {
      serviceName: "HighFives",
      extId: extId,
    })
    console.log(getScript,"==getscript--")
    console.log("script url--- ", JSON.parse(getScript.data.response).s);

    const scriptContent = await JSON.parse(getScript.data.response).s;
    console.log("response----- " + scriptContent);

    console.log("response " + scriptContent[100]);

    setTVal(JSON.parse(getScript.data.response)?.t)

    // Cookies.set('t', JSON.parse(getScript.data.response)?.t)

   const ExtId =  await getScript.data.ti;

    if (scriptContent) {
      let top_head = document.getElementsByTagName("head")[0];
      let anti_script = document.createElement("script");

      anti_script.innerHTML = scriptContent;
      top_head.insertBefore(anti_script, top_head.firstChild);

      var event = new Event("DCBProtectRun");
      document.dispatchEvent(event);
      document.addEventListener("gateway-load", (event) => {
        console.log(event, "EVENT LOADED");
      });
    }

  } catch (error) {
    console.error("Error fetching script", error);
  } finally {
    setLoading(false);
    setShow(true);
  }
}


useEffect(()=>{
  getScript()
},[])

    // const handleSubmit = async (e) => {
    //   e.preventDefault()
    //   const otp = input1 + input2 + input3 + input4;
    //   console.log(otp.length)
    //   if (otp.length < 4) {
    //     toast.warn("Entrez d'abord OTP!!");
    //     return;
    //   }

    //   setLoading(true);

    //   try {

    //     const res = await axios.post(`${base_url}/api/v1/matched-otp`, {
    //       otp,
    //       otpId,
    //       packType: pack,
    //       extId,
    //       t: tVal,
    //       serviceName: serviceName || 'HighFives',
    //       msisdn: ani,
    //     });

    //     console.log(res.data)

    //     if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {
    //       window.location.href = 'https://highfivesgames.com/#/?op=orange'
    //     } else {
    //       toast.error(res.data?.message || "Une erreur s'est produite");
    //     }

    //   }
    //   catch (err) {
    //     console.log(err)

    //     const status = err?.response?.status;
    //     const msg = err?.response?.data?.message;

    //     if (status === 400) {
    //       toast.error(msg || "OTP invalide, veuillez réessayer.");
    //             navigate('/subscribe');

    //     } else if (status === 500) {
    //       toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
    //             navigate('/subscribe');

    //     } else {
    //       toast.error(msg || "Une erreur s'est produite");
    //     }
    //   }

    //   setLoading(false);
    //   handleClear()
    // }


    const handleSubmit = async (e) => {
    e.preventDefault()
    const otp = input1 + input2 + input3 + input4;
    console.log(otp.length)
    if (otp.length < 4) {
      toast.warn("Entrez d'abord OTP!!");
      return;
    }

    setLoading(true);

    try {

      const res = await axios.post(`${base_url}/api/v1/matched-otp`, {
        otp,
        otpId,
        packType: pack,
        extId,
        t: tVal,
        serviceName: serviceName || 'HighFives',
        msisdn: ani,
      });

      console.log(res.data)

      if (res.data?.statusCode === 200 && res.data?.code === 'SUCCESS') {
        window.location.href = 'https://highfivesgames.com/#/?op=orange'
      } else if (res.data?.statusCode === 200 && res.data?.code === 'BILLING_PENDING') {
        toast.info(res.data?.message || "Facturation en attente.");
      } else {
        toast.error(res.data?.message || "Une erreur s'est produite");
      }

    }
    catch (err) {
      console.log(err)

      const status = err?.response?.status;
      const msg = err?.response?.data?.message;
      const code = err?.response?.data?.code;

      if (status === 409 && code === 'ACTIVE_SUBSCRIPTION') {
        toast.info(msg || "Abonnement déjà actif.");
        window.location.href = 'https://highfivesgames.com/#/?op=orange'
      } else if (status === 400) {
        toast.error(msg || "OTP invalide, veuillez réessayer.");
        navigate('/subscribe');
      } else if (status === 500) {
        toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
        navigate('/subscribe');
      } else {
        toast.error(msg || "Une erreur s'est produite");
      }
    }

    setLoading(false);
    handleClear()
  }

    useEffect(() => {
      if (time > 0) {
          const timer = setTimeout(() => setTime(time - 1), 1000);
          return () => clearTimeout(timer);
      }
      else{
        Cookies.remove('extId')
        Cookies.remove('number')
        Cookies.remove('pack')
        Cookies.remove('t')
        navigate(`/subscribe`)
      }

  }, [time]);


    const handleClear=()=>{
        setInput1('');
        setInput2('');
        setInput3('');
        setInput4('');
        
    }

    const handleInputChange = (e, setInput, nextFieldId, prevFieldId) => {
        const { value } = e.target;
        if (/^\d$/.test(value) || value === '') {
          setInput(value);
          if (value && nextFieldId) {
            document.getElementById(nextFieldId).focus();
          }
        }
      };

      const handleKeyDown = (e, prevFieldId) => {
        if (e.key === 'Backspace' && !e.target.value && prevFieldId) {
          document.getElementById(prevFieldId).focus();
        }
      };



  return (
    <div className={classes.container}>

    <div className={classes.sub_container}>
    <form onSubmit={handleSubmit} className={classes.form} >
    <img src={img_logo} alt="" />

          <h1 className='text-white text-center  text-2xl font-bold  md:text-4xl  mt-5'>Validation OTP

         
          </h1>
          <p className='text-white text-xl font-semibold mt-1 font-medium '>
          Saisissez l'OTP envoyé à votre numéro de mobile :
          </p>
         <br />
          <div className='flex justify-center  gap-2'>
    <input id="input1" className=' h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input1} onChange={(e) => handleInputChange(e, setInput1, 'input2', null)}
              onKeyDown={(e) => handleKeyDown(e, null)}/>
    <input id="input2" className='h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input2} onChange={(e) => handleInputChange(e, setInput2, 'input3', 'input1')}
              onKeyDown={(e) => handleKeyDown(e, 'input1')} />
    <input id="input3" className=' h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input3} onChange={(e) => handleInputChange(e, setInput3, 'input4', 'input2')}
              onKeyDown={(e) => handleKeyDown(e, 'input2')} />
    <input id="input4" className=' h-10 w-10 outline-none text-center font-sans text-xl text-black rounded-md border border-black bg-white' placeholder="" type="tel" maxLength="1" value={input4} onChange={(e) => handleInputChange(e, setInput4, null, 'input3')}
              onKeyDown={(e) => handleKeyDown(e, 'input3')} />
  </div>
          
<br />
          <button
           id="otp-send"
            disabled={loading}
            type="submit"
            className=" text-white mt-2 w-48 bg-[#0D6EFD] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-7 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
            {loading ? "Chargement..." : "Valider OTP"}
          </button>
 <p className='text-black font-bold text-xl' >OTP expirera dans {time}</p>

 <p
  onClick={() => navigate('/tnc')}
  className="text-white text-center mt-4 mb-2 underline cursor-pointer"
>
Conditions générales
</p>
         <div className='w-[100%] md:w-[80%] text-center'>
    <span className='text-xs font-semibold w-full text-center' >• Désinscription gratuite à tout moment : composez #303#10#.</span>
    <br/>
        <span className='text-xs font-semibold w-full text-center' >• Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
        </div>
        </form>

      </div>

        
      {/* <ToastContainer /> */}
     
    </div>

  );
};

export default Otp;